"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCountryOptions = void 0;
var _react = require("react");
var _useTranslation2 = require("../../../../hooks/useTranslation/useTranslation");
var _countries = require("../../../../constants/countries/countries");
var useCountryOptions = function useCountryOptions() {
  var codes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _countries.COUNTRIES.map(function (c) {
    return c.code;
  });
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  var options = (0, _react.useMemo)(function () {
    return codes.map(function (c) {
      return {
        label: {
          text: t("countries.".concat(c))
        },
        value: c
      };
    });
  }, [t, codes]);
  return options;
};
exports.useCountryOptions = useCountryOptions;